import { CUSTOM_ELEMENTS_SCHEMA, inject, NgModule } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GridsterModule } from 'angular-gridster2';
import { FileUploadModule } from 'ng2-file-upload';

import { AppSharedModule } from 'app/app-shared.module';
import { WidgetModule } from 'app/modules/widget/widget.module';
import { AuthGuardService } from 'app/providers/bridge-api/auth.service';

import { GroupRouteGuardService } from 'app/services/group-route-guard.service';

import { ActionPlanModule } from '../action-plan/action-plan.module';
import { ProjectCollectionActionsComponent } from '../project/components/project-collection-actions/project-collection-actions.component';
import { GridAnalyticItemSelectorDialogComponent } from '../widget/components/grid-analytic-item-selector-dialog/grid-analytic-item-selector-dialog.component';
import { JourneyAnalyticItemSelectorDialogComponent } from '../widget/components/journey-analytic-item-selector-dialog/journey-analytic-item-selector-dialog.component';
import { DashboardPillWrapperComponent } from '../../components/dashboard-pill-wrapper/dashboard-pill-wrapper.component';
import { ActionPlanSidePaneItemComponent } from './components/action-plan-side-pane-item/action-plan-side-pane-item.component';
import { AddActionPlanDialogComponent } from './components/add-action-plan-dialog/add-action-plan-dialog.component';
import { ApplyComparisonDialogComponent } from './components/apply-comparison-dialog/apply-comparison-dialog.component';
import { ComparisonChooserComponent } from './components/comparison-chooser/comparison-chooser.component';
import { ComparisonSidePaneItemComponent } from './components/comparison-side-pane-item/comparison-side-pane-item.component';
import { CreateComparisonDrawerComponent } from './components/create-comparison-drawer/create-comparison-drawer.component';
import { CreateAliasDialogComponent } from './components/dashboard-options/create-alias-dialog/create-alias-dialog.component';
import { DashboardOptionGeneralComponent } from './components/dashboard-options/dashboard-option-general/dashboard-option-general.component';
import { DashboardOptionHistoryComponent } from './components/dashboard-options/dashboard-option-history/dashboard-option-history.component';
import { DashboardOptionMetadataComponent } from './components/dashboard-options/dashboard-option-metadata/dashboard-option-metadata.component';
import { DashboardOptionPermissionsComponent } from './components/dashboard-options/dashboard-option-permissions/dashboard-option-permissions.component';
import { DashboardOptionSaveAndExportComponent } from './components/dashboard-options/dashboard-option-save-and-export/dashboard-option-save-and-export.component';
import { DashboardOptionsComponent } from './components/dashboard-options/dashboard-options.component';
import { DashboardPageRenameDialogComponent } from './components/dashboard-page-rename-dialog/dashboard-page-rename-dialog.component';
import { DashboardPageReorderDialogComponent } from './components/dashboard-page-reorder-dialog/dashboard-page-reorder-dialog.component';
import { DashboardSidePaneComponent } from './components/dashboard-side-pane/dashboard-side-pane.component';
import { DatasourceSelectorComponent } from './components/datasource-selector/datasource-selector.component';
import { SavedViewCreateDialogComponent } from './components/saved-view-create/saved-view-create.component';
import { SavedViewSidePaneItemComponent } from './components/saved-view-side-pane-item/saved-view-side-pane-item.component';
import { WidgetGroupChooserComponent } from './components/widget-group-chooser/widget-group-chooser.component';
import { WidgetGroupCreateDialogComponent } from './components/widget-group-create/widget-group-create.component';
import { WidgetGroupDataSourceSelectorDialogComponent } from './components/widget-group-datasource-selector/widget-group-datasource-selector.component';
import { WidgetGroupSidePaneItemComponent } from './components/widget-group-side-pane-item/widget-group-side-pane-item.component';
import { DashboardDetailsComponent } from './pages/dashboard-details/dashboard-details.component';
import { DashboardViewComponent } from './pages/dashboard-view/dashboard-view.component';
import { CanDeactivateDashboardViewService } from './services/can-deactivate-dashboard-view.service';

@NgModule({
  imports: [
    GridsterModule,
    FileUploadModule,
    NgbModule,
    AppSharedModule,
    WidgetModule,
    NoopAnimationsModule,
    ActionPlanModule,
    RouterModule.forRoot(
      [
        {
          canActivate: [AuthGuardService, GroupRouteGuardService],
          path: 'groups/:groupId/projects/:projectId/dashboards/:dashboardId',
          component: DashboardDetailsComponent,
          canDeactivate: [
            (component: DashboardDetailsComponent) =>
              inject(CanDeactivateDashboardViewService).canDeactivate(component),
          ],
          runGuardsAndResolvers: 'always',
        },
        {
          canActivate: [AuthGuardService],
          path: 'd/:dashboardAlias',
          component: DashboardDetailsComponent,
          canDeactivate: [
            (component: DashboardDetailsComponent) =>
              inject(CanDeactivateDashboardViewService).canDeactivate(component),
          ],
          runGuardsAndResolvers: 'always',
        },
      ],
      { onSameUrlNavigation: 'reload' }
    ),
    DashboardSidePaneComponent,
    WidgetGroupSidePaneItemComponent,
    ComparisonSidePaneItemComponent,
    SavedViewSidePaneItemComponent,
    SavedViewCreateDialogComponent,
    CreateComparisonDrawerComponent,
    DatasourceSelectorComponent,
    ApplyComparisonDialogComponent,
    CreateAliasDialogComponent,
    ActionPlanSidePaneItemComponent,
    ProjectCollectionActionsComponent,
    ComparisonChooserComponent,
    WidgetGroupChooserComponent,
    DashboardPillWrapperComponent,
    GridAnalyticItemSelectorDialogComponent,
    DashboardOptionHistoryComponent,
    JourneyAnalyticItemSelectorDialogComponent,
    MatTabsModule,
  ],
  providers: [CanDeactivateDashboardViewService],
  declarations: [
    DashboardViewComponent,
    DashboardDetailsComponent,
    WidgetGroupCreateDialogComponent,
    WidgetGroupDataSourceSelectorDialogComponent,
    DashboardPageReorderDialogComponent,
    DashboardPageRenameDialogComponent,
    DashboardOptionsComponent,
    DashboardOptionMetadataComponent,
    DashboardOptionGeneralComponent,
    DashboardOptionSaveAndExportComponent,
    DashboardOptionPermissionsComponent,
    AddActionPlanDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DashboardModule {}
